const wpImageSizeCollectionType = {
  EXTRA_BIG: 'EXTRA_BIG',
  BIG: 'BIG',
  MEDIUM: 'MEDIUM',
  SMALL: 'SMALL',
  LOGO: 'LOGO',
};

export default wpImageSizeCollectionType;
